import { Box, Stack } from "@mui/material";
import { useCallback } from "react";
import CalculatorFilterMobileHeader from "./calculatorFilterMobileHeader";
import CalculatorStepper from '../../calculatorStepper';
import CalculatorFilterMobileForm from "./calculatorFilterMobileForm";

const CALCULATOR_HEADER = [
    {
        title: "Site & Activity Pricing!",
        description: "Instantly calculate total costs by combining site entrance fees, and activity rates in one place."
    }
]

const CalculatorMobileFilter = ({
    defaultData, 
    moveToFormView,
    buttonLoading,
    dropDownDataLoading,
    tourSitesAndActivities
}) => {
    const moveNextStep = useCallback((data) => {
        console.log(data);
        
        moveToFormView(data.sites, data.activities, data.kids, data.adults);
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignContent='center'
                width='100%'
                pb={10}
                data-aos="fade-up"
            >
                <Box sx={{px: 2.5, pt: 3}}>
                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignContent='center'
                        width='100%'
                        spacing={2}
                    >
                        <CalculatorFilterMobileHeader data={CALCULATOR_HEADER[0]}/>

                        {/* Stepper */}
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='center'
                            pt={2}
                        >
                            <CalculatorStepper 
                                step={0}
                                stepList={[0,1]}
                            />
                        </Stack>

                        <CalculatorFilterMobileForm 
                            moveNextStep={moveNextStep}
                            defaultData={defaultData}
                            buttonLoading={buttonLoading}
                            dropDownDataLoading={dropDownDataLoading}
                            tourSitesAndActivities={tourSitesAndActivities}
                        />
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default CalculatorMobileFilter;